import * as React from 'react';

import PropTypes from 'prop-types';

import {getDashComponent} from '../../../dashboard-component-map';
import {getDashLabel} from '../../../dashboard-constants';
import {getDashSubheader} from '../../../dashboard-helpers';

import {DashComponent} from '../../dash';
import {DashLoading} from '../../dash-loading';

import styles from './dash-config-preview.module.css';

export class DashConfigPreview extends React.Component {
    static propTypes = {
        type: PropTypes.string.isRequired,
        title: PropTypes.string,
        preview: PropTypes.any,
        isLoading: PropTypes.bool,
        isRefreshing: PropTypes.bool,
        errorMessage: PropTypes.string,
        loggedInUser: PropTypes.object,
        query: PropTypes.string,
    };

    static defaultProps = {
        isLoading: false,
        isRefresing: false,
    };

    render() {
        return (
            <div className={styles['preview-container']}>
                <DashComponent
                    id='preview'
                    title={this.props.title}
                    subheader={getDashSubheader({...this.props, data: this.props.preview})}
                    type={getDashLabel(this.props.type)}
                    data={this.props.preview}
                    isPreview={true}
                    isConfigurable={false}
                    isRefreshingComponent={this.props.isRefreshing && !this.props.isLoading}
                >
                    {this.renderPreviewComponent()}
                </DashComponent>
            </div>
        );
    }

    renderPreviewComponent = () => {
        if (this.props.isLoading) {
            return <DashLoading />;
        }

        const PreviewComponent = getDashComponent(this.props.type);

        return (
            <PreviewComponent
                {...this.props.preview}
                loggedInUser={this.props.loggedInUser}
                query={this.props.query}
            />
        );
    };
}
